export const shouldAllowMagnification = (currentTarget) => {
  const containerDimension = {
    height: currentTarget.height,
    width: currentTarget.width,
  };

  const imageDimension = {
    height: currentTarget.naturalHeight,
    width: currentTarget.naturalWidth,
  };

  return (
    containerDimension.height < imageDimension.height &&
    containerDimension.width < imageDimension.width
  );
};
